// @flow
// Types
import type {
  Shape,
} from 'fc-flow-types/models'

// Libs
import React from 'react'

// Components
import ShapeSvg from 'fc-components-shapes/src/ShapeSvg'

// Exports
export default function ShapeCell ({ shape }: { shape: Shape }): React.Element<{shape: Shape}> {
  return (
    <ShapeSvg shape={shape} />
  )
}
